import * as React from 'react';
import { Provider } from 'react-redux';
import { lazy, Suspense } from 'react';

import { ResultsProps } from './Results/Results';
import { createStore } from '../store';
import { useGraphQLClient } from '../../graphql-client';
import { GuardedApolloProvider } from '../../GuardedApolloProvider';

const Results = lazy(() => import('./Results/Results'));

const Component: React.FunctionComponent<ResultsProps> = props => {
	const client = useGraphQLClient();
	const store = createStore(props.searchResults);

	return (
		<Provider store={store}>
			<GuardedApolloProvider client={client}>
				<Suspense fallback={<div />}>
					{/* TODO: удалить локальные модалки ошибок и после влючить глобальный ErrorManager */}
					{/* <ErrorManager /> */}

					<Results {...props} />
				</Suspense>
			</GuardedApolloProvider>
		</Provider>
	);
};

export default Component;
